import { AfterViewInit, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MediaGalleryItem } from '../media-gallery-item/media-gallery-item.model';
import { MultimediaManagerDialogItem, MultimediaManagerDialogItemTypes } from 'src/app/modules/multimedia-manager/multimedia-manager-dialog/multimedia-manager-dialog-item.model';
import { PhotoEditorService } from 'src/app/modules/photo-editor/photo-editor/photo-editor.service';

@Component({
  selector: 'app-media-gallery-zoom-dialog',
  templateUrl: './media-gallery-zoom-dialog.component.html',
  styleUrls: ['./media-gallery-zoom-dialog.component.scss']
})
export class MediaGalleryZoomDialogComponent implements OnInit, AfterViewInit {

  @ViewChild('img', { static: false }) imgRef: ElementRef;
  editingTitle;
  mmdialogItem: MultimediaManagerDialogItem;
  zoomValues = [25, 33, 50, 67, 75, 80, 90, 100, 110, 125, 150, 175, 200, 250, 300, 400, 500]

  constructor(@Inject(MAT_DIALOG_DATA) public data: MediaGalleryItem,
              private photoEditorService: PhotoEditorService,
              public dialogRef: MatDialogRef<MediaGalleryZoomDialogComponent>) {
                this.editingTitle = false;
                if (data.Type === 'WEB_SCRIPT') {
                  this.mmdialogItem = this.unparseMMDialogItem(data);
                }
               }

  ngOnInit() { }

  ngAfterViewInit() {
    if (this.imgRef) {
      this.imgRef.nativeElement.style.maxHeight = window.innerHeight * 0.5 + 'px';
    }
  }

  public save() {
    switch (this.data.Type) {
      case 'WEB_SCRIPT':
        this.photoEditorService.save();
      break;
      default:
        this.saveItem();
      break;
    }
  }
  public saveItem() {
    this.dialogRef.close({ action: 'save', data: this.data });
  }

  public uploadItem() {
    this.dialogRef.close({ action: 'update', data: null });
  }

  public deleteItem() {
    this.dialogRef.close({ action: 'delete', data: null });
  }

  private unparseMMDialogItem(mediaGalleryItem: MediaGalleryItem) {
    const item = new MultimediaManagerDialogItem();
    item.Url = mediaGalleryItem.Content;
    item.InternalId = mediaGalleryItem.Id;
    item.Name = mediaGalleryItem.Title;
    item.Type = MultimediaManagerDialogItemTypes.WEB_SCRIPT;
    return item;
  }

  public webscriptResultOutputEvent(e) {
    this.data.Content = e;
    this.saveItem();
  }

  public setPreselected2(op1, op2) {
    if (op1 && op2) {
      return op1 === op2;
    }
  }

}
